import type { LoaderFunction } from "@remix-run/server-runtime";
import * as routeUtils from "~/contentful/route-utils";
import { SitemapHandle } from "~/seo/sitemap.server";

export const headers = routeUtils.headers;

export const handle: SitemapHandle = {
  id: "home",
  getSitemapEntries: async () => {
    return [
      {
        route: "/",
        changefreq: "daily",
        priority: 1.0,
      },
    ];
  },
};

export const meta = routeUtils.meta;

export const shouldRevalidate = routeUtils.shouldRevalidate;

export const loader: LoaderFunction =
  routeUtils.getContentfulPageLoader("home");

export default routeUtils.ContentfulPageComponent;

export const ErrorBoundary = routeUtils.ContentfulErrorBoundary;
